<template>
  <card>
    <h4 slot="header" v-if="result" class="card-title text-center">{{result}}</h4>
    <form>
      <div class="row">
        <div class="col-md-4">
          <base-input type="text"
                    label="Campaign Name"
                    placeholder="Campaign Name"
                    v-model="campaign.name">
          </base-input>
        </div>
        <div class="col-md-4">
          <base-input type="text"
                    label="Campaign Start Date"
                    placeholder="Campaign Start Date"
                    v-model="campaign.startTime">
          </base-input>
        </div>
        <div class="col-md-4">
          <base-input type="text"
                    label="Campaign End Date"
                    placeholder="Campaign End Date"
                    v-model="campaign.endTime">
          </base-input>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <label class="control-label">
            Select Client
          </label>
          <br />
          <button v-for="(client, index) in clients" @click="selectClient(client)" type="button" :class="['btn', 'btn-sm', 'mr-1', 'mb-1', campaign.client && campaign.client === client._id ? 'btn-primary' : 'btn-secondary']">{{ client.name }}</button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <label class="control-label">
            Selected Drivers
          </label>
          <br />
          <button v-for="(driver, index) in selectedDrivers" @click="removeDriver(index)" type="button" :class="['btn', 'btn-sm', 'mr-1', 'mb-1', 'btn-primary']">{{ driver }}</button>
        </div>
      </div>
      <div class="text-center">
        <button v-if="!loading && (campaign.name && campaign.startTime && campaign.endTime && selectedDrivers && selectedDrivers.length && campaign.client)" type="submit" class="btn btn-info btn-fill float-right" @click.prevent="createCampaign">
          Create Campaign
        </button>
      </div>
      <div class="clearfix"></div>
    </form>
  </card>
</template>
<script>
  import { getApp } from 'firebase/app';
  import { getFunctions, httpsCallable, connectFunctionsEmulator } from "firebase/functions";
  import Card from 'src/components/Cards/Card.vue'

  export default {
    components: {
      Card
    },
    props: {
      selectedDrivers: Array,
    },
    data () {
      return {
        loading: false,
        result: '',
        campaign: {
          name: '',
          startTime: null,
          endTime: null,
          client: '',
        },
        clients: '',
      }
    },
    async created() {
      await this.getClients();
    },
    methods: {
      async getClients () {
        try {
          this.loading = true
          const app = getApp()
          const functions = getFunctions(app, 'europe-west1')
          // connectFunctionsEmulator(functions, "127.0.0.1", 5001);
          const getClients = httpsCallable(functions, 'getClients');
          const getClientsRes = await getClients();
          this.clients = getClientsRes && getClientsRes.data
        } catch (error) {
          console.log('getClientsError', error)
          this.result = 'Error: ' + error
        } finally {
          this.loading = false;
        }
      },
      async createCampaign () {
        try {
          this.loading = true
          const app = getApp()
          const functions = getFunctions(app, 'europe-west1')
          // connectFunctionsEmulator(functions, "127.0.0.1", 5001);
          const createCampaign = httpsCallable(functions, 'createCampaign');
          this.campaign.drivers = this.selectedDrivers;
          await createCampaign(this.campaign)
          this.result = 'Campaign Created Successfully'
        } catch (error) {
          this.result = 'Error: ' + error
        } finally {
          this.loading = false;
        }
      },
      removeDriver(index) {
        this.$emit('removeDriver', index)
      },
      async selectClient(client) {
        try {
          console.log('client', client)
          this.campaign.client = client._id
        } catch (error) {
          console.log('selectClientError', error)
        }
      }
    }
  }

</script>
<style>

</style>
